import styled from 'styled-components';

// Multimedia
const StyledMultimedia = styled.div`
  width: 100%;
`;
// Imagenes
const StyledImg = styled.div`
  width: 100%;
  & img {
    width: 100%;
`;

export { StyledMultimedia, StyledImg };
